import template from './filterAutocompleteWithDropdownView.html';
import { FilterAutocompleteWithDropdownController } from './filterAutocompleteWithDropdownController';
export const FilterAutocompleteWithDropdownComponent = {
    require: {
        ngModel: '?ngModel',
    },
    controller: FilterAutocompleteWithDropdownController,
    controllerAs: '$ctrl',
    template,
    bindings: {
        title: '@?',
        label: '@?',
        placeholder: '@?',
        handleFilter: '&?',
        getOptions: '&?',
    },
};
